import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Grid,
  TextField,
  CircularProgress,
} from "@mui/material";
import "../../Sass/Common.scss";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { connect } from "react-redux";
import {
  START_UPDATE_REPEAT_ORDER_DATE,
  RESET_REPEAT_ORDER_STATE,
} from "Actions/RepeatOrderAction";
import * as yup from "yup";
import { useFormik } from "formik";
import { useXssGuard } from "Hooks/useXssGuard";
import moment from "moment";
import { START_GET_NO_OF_ALERT } from "Actions/HomeAction";
import useHeaderPharmacySelection from "Hooks/useHeaderPharmacySelection";
import { START_UPDATE_FIELD_PATIENT } from "../../Actions/PatientAction";
import { ReactComponent as NoteTextIcon } from "../../Assets/Icons/PharmsmartIcon/NoteTextcon.svg";

const EditDobDialog = (props) => {
  const {
    open,
    setOpen,
    editData,
    setEditData,
    getList,
    updatePatientData,
    updatePatientFieldAction,
    type,
    subscriptionDialog,
    setSubscritionDialog,
    loginUserDetail,
  } = props;
  const [isOpenDate, setIsOpenDate] = React.useState(false);
  const [dob, setDob] = React.useState("");
  //   const [dateDate, setDateData] = useState({
  //     id: "",
  //     order_date: "",
  //     medication_date: "",
  //   });
  //   const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  //   const query = new URLSearchParams(window.location.search);

  //   /** Medication Date validation function */
  //   const medicationValidation = (medicationDate, orderDate) => {
  //     let isValid = true;
  //     let errorMessage = "";
  //     if (
  //       orderRecordActionType === "medication_date" &&
  //       moment(medicationDate).isBefore(moment(new Date(new Date() - 86400000)))
  //     ) {
  //       isValid = false;
  //       errorMessage =
  //         "The medication start date should be after the order date.";
  //     } else if (medicationDate && !moment(orderDate).isBefore(medicationDate)) {
  //       isValid = false;
  //       errorMessage = "The medication date must be a date after order date.";
  //     }
  //     return {
  //       isValid,
  //       errorMessage,
  //     };
  //   };
  let today = new Date();
  let yestarday = new Date(new Date(today).setDate(today.getDate() - 1));
  //   /** Validation schema */
  const DateSchema = yup.object().shape({
    dob: yup
      .date()
      .nullable()
      .typeError("Date must be follow this format DD-MM-YYYY")
      // .required("The date of birth field is required.")
      .max(yestarday, "The DOB can not be the future date or current date "),
  });
  //   /** Handle Update Date Function */
  const handleUpdateDate = (formValues) => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    const payload = {
      dob: dob ? moment(new Date(dob)).format("YYYY-MM-DD") : null,
    };
    // if (type === "patient") {
    if (editData?.dob === null && dob === null) {
      handleClose();
    } else {
      updatePatientFieldAction(
        type === "patient" ? editData?.id : editData?.patient_id,
        payload
      );
    }
    // }
  };

  const { guardedSubmit: xssGuardedEditDob } = useXssGuard(handleUpdateDate);

  //   /** UseFormik */
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    resetForm,
    setErrors,
    setFieldValue,
    handleBlur,
  } = useFormik({
    initialValues: { dob },
    validationSchema: DateSchema,
    enableReinitialize: true,
    onSubmit: xssGuardedEditDob,
  });

  //   /** Handle Close Funcation */
  const handleClose = () => {
    setOpen(false);
    setEditData({});
    resetForm();
    setDob("");
  };

  /** User popup popup then show selected date useEffect */
  useEffect(() => {
    if (Object.keys(editData)?.length) {
      setDob(editData?.dob ? editData?.dob : "" || null);
    }
  }, [open]);
  //   /** Server Side validation UseEffect */
  useEffect(() => {
    const errors = updatePatientData;
    if (errors && Object?.keys(errors)?.length > 0) {
      let obj = {};
      Object.entries(errors)?.map(([item, value]) => {
        obj[item] = value[0];
        return item;
      });
      setErrors(obj);
    }
  }, [updatePatientData?.error]);

  //   /** Date Update useEffect */
  useEffect(() => {
    if (
      !updatePatientData?.loading &&
      Object.keys(updatePatientData?.data || {})?.length > 0
    ) {
      handleClose();
    }
  }, [updatePatientData]);

  useEffect(() => {
    if (updatePatientData?.data?.success) {
      // getList();
    }
  }, [updatePatientData?.data?.success]);

  return (
    <>
      <Dialog
        className="RSxs_modal"
        open={open}
        maxWidth={"xs"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <PrimaryDialogTitle
          title={editData?.dob ? "Edit Date" : "Add Date"}
          handleClose={handleClose}
          icon={NoteTextIcon}
          className="Rsheading_form"
        />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          className="RsDf_form"
        >
          <DialogContent>
            <Grid
              container
              columnSpacing={2.5}
              rowSpacing={3}
              className="paddingdobHeader"
            >
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    disableFuture
                    label="Date of birth "
                    views={["year", "month", "day"]}
                    inputFormat="DD-MM-YYYY"
                    value={dob}
                    onFocus={() => setIsOpenDate(true)}
                    open={() => setIsOpenDate(true)}
                    onClose={() => {
                      setIsOpenDate(false);
                    }}
                    onChange={(newDate) => {
                      setDob(newDate);
                      // returnServerError("");
                    }}
                    renderInput={(params) => (
                      <TextField
                        id="dob"
                        fullWidth
                        size="small"
                        inputFormat="DD-MM-YYYY"
                        name="dob"
                        {...params}
                        error={
                          touched?.dob && errors?.dob
                          // ||
                          // returnServerError("dob").keyPresent
                        }
                        helperText={
                          touched?.dob && errors?.dob
                          // ||
                          // returnServerError("dob").message
                        }
                        onBlur={handleBlur}
                      />
                    )}
                    name="dob"
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              className="BtnGreen"
              variant="contained"
              type="submit"
              disabled={updatePatientData?.loading}
              startIcon={
                updatePatientData?.loading && (
                  <CircularProgress color="white" size="20px" />
                )
              }
            >
              Submit
            </Button>
            <Button
              className="BtnGray"
              variant="outlined"
              onClick={() => handleClose()}
            >
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  updateRepeatOrderDates: state.order.updateRepeatOrderDates,
  updatePatientData: state.patient.updatePatientData,
});
const mapDispatchToProps = (dispatch) => ({
  updatePatientFieldAction: (id, payload) =>
    dispatch({ type: START_UPDATE_FIELD_PATIENT, id, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditDobDialog);
